var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.meState
    ? _c(
        "div",
        [
          _c("LayoutDefaultHeader"),
          _c("LayoutDefaultNavDrawer"),
          _c("v-main", [_vm._t("default")], 2),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }